import React, { useMemo } from 'react'

import Cookie from 'js-cookie'
import { faGraduationCap, faLink, faUnlink } from '@fortawesome/pro-solid-svg-icons'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'
import { Select, Tag } from 'antd'

import { OrderBy } from '../../../utils/constants'
import { getUser } from '../../../reducers/UserReducer'
import { getAddress, getEmail, getName, getPhoneNumber } from '../../../utils/entities/school'
import { TableParameters } from '../../../utils/entities/tableParameters'
import {
  Action,
  DeleteAction,
  ExternalAction,
  TableActions
} from '../../../Components/antd/Tables/DataTable/utils/actions'
import { buildFilters, Filter } from '../../../Components/antd/Tables/DataTable/utils/tableFilter'
import DataTable from '../../../Components/antd/Tables/DataTable/DataTable'

export const GLOBAL_INSTITUTION = 'global_institution'

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const SchoolsTable = ({
  context = null, data, help, loading, pendingLinkRequests, metadata, parameters, user,
  onParametersChange, onSelectInstitution, onTriggerAction, openModal, t
}) => {
  const maxHeight = useMemo(() => `calc(100vh - ${Cookie.get('switch_user_id') ? '180px' : '139px'})`, [Cookie.get('switch_user_id')])
  const columns = useMemo(() => [
    {
      title: t('schools_table.column_title.name'),
      orderBy: OrderBy.NAME,
      key: s => {
        const name = getName(s)

        return name.length > 50 ? `${name.slice(0, 47)}...` : name
      },
      tooltip: getName
    },
    { title: t('schools_table.column_title.phone_number'), orderBy: OrderBy.PHONE_NUMBER, key: getPhoneNumber },
    { title: 'Email', orderBy: OrderBy.EMAIL, key: getEmail },
    { title: t('schools_table.column_title.address'), orderBy: OrderBy.ADDRESS, key: getAddress },
    {
      title: t('schools_table.column_title.linked'),
      key: s => <Tag color={s.linked ? 'green' : 'red'}> {t(s.linked ? 'schools_table.linked' : 'schools_table.not_linked')} </Tag>
    }
  ], [t])
  const actions = useMemo(() => {
    let actions = {
      link: TableActions.LINK_INSTITUTION_SCHOOL,
      unlink: TableActions.UNLINK_INSTITUTION_SCHOOL
    }

    if (context === GLOBAL_INSTITUTION) {
      actions = {
        link: TableActions.LINK_INSTITUTION_GROUP_SCHOOL,
        unlink: TableActions.UNLINK_INSTITUTION_GROUP_SCHOOL
      }
    }

    return [
      new Action({
        title: 'data_table.actions.view_school_sections',
        icon: faGraduationCap,
        onClick: s => onTriggerAction(s, TableActions.SELECT)
      }),
      new Action({
        title: 'data_table.actions.link',
        icon: faLink,
        onClick: s => onTriggerAction(s, actions.link),
        toRender: s => !s.linked
      }),
      new DeleteAction({
        onDelete: s => onTriggerAction(s, actions.unlink),
        title: 'schools_table.not_linked',
        icon: faUnlink,
        popconfirmTitle: 'delete_action.pop_confirm.unlink',
        toRender: s => s.linked
      })
    ]
  }, [onTriggerAction, onSelectInstitution])
  const filters = useMemo(() => buildFilters([
    new Filter({
      key: 'lockedInstitution',
      label: t('schools_table.linked'),
      component: ({ data = [], value = null, onChange }) => {
        return (
          <Select onChange={onChange} value={value === null ? null : +value} style={{ width: '200px' }}>
            {data.map(d => {
              return (
                <Select.Option key={d.name} value={d.value}>
                  {d.color && <Tag color={d.color}>{t(d.name)} </Tag>}
                  {!d.color && t(d.name)}
                </Select.Option>
              )
            })}
          </Select>
        )
      },
      props: {
        data: [{ name: t('schools_table.linked'), value: 1, color: 'green' }, { name: t('schools_table.not_linked'), value: 0, color: 'red' }, { name: '/', value: null }],
        value: parameters.filters.lockedInstitution ?? null,
        onChange: value => onParametersChange(new TableParameters({ ...parameters, filters: { ...parameters.filters, lockedInstitution: value === null ? null : !!value } }))
      }
    })
  ]), [t, parameters, onParametersChange])

  const externalActions = useMemo(() => [
    new ExternalAction({
      title: t('schools_table.external_actions.display_link_requests'),
      onClick: openModal
    })
  ], [openModal, t])

  return (
    <div style={{ height: maxHeight }}>
      <DataTable
        actions={actions}
        columns={columns}
        data={data}
        externalActions={externalActions}
        filters={filters}
        help={help}
        loading={loading}
        metadata={metadata}
        parameters={parameters}
        onParametersChange={onParametersChange}
      />
    </div>
  )
}

export default connect(mapStateToProps)(SchoolsTable)
